module.exports = __webpack_public_path__ + "img/google.c9cfff25.png";